import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const FirmwareViewModule = new Module({
  id: 'FIRMWARE:VIEW:RESULT-TABLE',
  name: 'Firmwares',
  label: 'Firmwares',
  path: 'firmware',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Firmwares/View'))
  ),
  actions: {
    copy: {
      id: 'FIRMWARE:COPY:RESULT-TABLE',
      name: 'copy',
      label: 'Copy As Template'
    },
    edit: {
      id: 'FIRMWARE:EDIT:RESULT-TABLE',
      name: 'edit',
      label: 'Edit'
    },
    delete: {
      id: 'FIRMWARE:DELETE:RESULT-TABLE',
      name: 'delete',
      label: 'Delete'
    },
    downloadBin: {
      id: 'FIRMWARE:ACTION:BIN_DOWNLOAD',
      name: 'FOTA File Download',
      label: 'FOTA File'
    },
    downloadHex: {
      id: 'FIRMWARE:ACTION:HEX_DOWNLOAD',
      name: 'Full Package File Download',
      label: 'Full Package File'
    }
  }
});

export const FirmwareAddModule = new Module({
  id: 'FIRMWARE:CREATE:NEW-FIRMWARE',
  name: 'firmwareAdd',
  path: 'firmware/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Firmwares/Form'))
  ),
  actions: {
    add: {
      id: 'FIRMWARE:CREATE:NEW-FIRMWARE',
      name: 'Firmware Add',
      label: 'Add Firmware'
    }
  }
});

export const FirmwareEditModule = new Module({
  id: 'FIRMWARE:EDIT:RESULT-TABLE',
  name: 'firmwareEdit',
  path: 'firmware/edit/:firmwareId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Firmwares/Form'))
  )
});

const FirmwareModules = [
  FirmwareViewModule,
  FirmwareAddModule,
  FirmwareEditModule
];

export default new ModuleBundle('Firmware', FirmwareModules);
